"use client";

import { createContext, type ReactNode, useContext } from "react";
import { DEFAULT_LANGUAGES, type TenantLanguages } from "./types";

const LanguagesContext = createContext<TenantLanguages | null>(null);

/**
 * Provider that supplies the resolved tenant languages to client components.
 * Both the storefront and admin layouts wrap children with this so consumers
 * never need to hit `brand_config` from the browser.
 */
export function LanguagesProvider({
  value,
  children,
}: {
  value: TenantLanguages;
  children: ReactNode;
}) {
  return (
    <LanguagesContext.Provider value={value}>
      {children}
    </LanguagesContext.Provider>
  );
}

/**
 * Read the tenant's configured languages. Returns DEFAULT_LANGUAGES if the
 * caller is rendered outside `LanguagesProvider` (shouldn't happen in
 * production trees — both admin and storefront layouts provide it).
 */
export function useLanguageConfig(): TenantLanguages {
  return useContext(LanguagesContext) ?? DEFAULT_LANGUAGES;
}
